import React, { useState } from 'react'
import TipJarButton from './tipJarButton'
import WhiteCloseIcon from '../../assets/close-icon-small-tip-jar.svg'
import ArrowTipJar from '../../assets/up-arrow-tip-jar.svg'
import { isEmpty } from 'lodash'
import { isMobile } from 'react-device-detect'

const TipButtonsBar = ({
  tipJarButtons = [],
  activatePipMode = () => {},
  bottomClass = 'bottom-[70px] md:bottom-[80px]',
}) => {
  const [tipBarOpen, setTipBarOpen] = useState(true)
  const [hover, setHover] = useState(false)
  const [isMinimized, setIsMinimized] = useState(true)

  return (
    <>
      {tipBarOpen ? (
        <div
          style={{
            background: hover ? '#00000040' : '',
            zIndex: 50,
            width: 'min-content',
            transition: 'all 0.25s ease-in',
            // marginLeft: 'auto',
            // marginRight: 'auto',
            border: isMobile ? 'solid 0.25px #fff' : '',
          }}
          className={`flex flex-col md:flex-row items-center absolute mx-2 md:left-0 right-[45px] ${bottomClass} md:right-0 md:mx-auto md:p-[22px] rounded `}
          onMouseOver={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <div
            className="md:hidden absolute right-0 cursor-pointer flex justify-center items-center"
            style={{
              width: '22px',
              height: '12px',
              background: '#ffffff',
              top: '-12px',
              borderTopLeftRadius: '4px',
              borderTopRightRadius: '4px',
            }}
          >
            <img
              src={ArrowTipJar}
              alt="Logo"
              className={`${!isMinimized && 'rotate-180'} w-[9px]   `}
              style={{
                transition: '.25s',
              }}
              onClick={() => {
                setIsMinimized(!isMinimized)
              }}
            />
          </div>

          {!isEmpty(tipJarButtons)
            ? tipJarButtons.map((info, idx) => (
                <div
                  className="hidden md:block"
                  style={{ marginLeft: idx ? '34px' : '' }}
                  key={idx}
                >
                  <TipJarButton tipJarButtonInfo={info} activatePipMode={activatePipMode} />
                </div>
              ))
            : null}

          {!isEmpty(tipJarButtons)
            ? tipJarButtons
                .filter((e, idx) => (isMinimized ? idx < 1 : true))
                .map((info, idx) => (
                  <div className="block md:hidden" key={idx}>
                    <TipJarButton
                      tipJarButtonInfo={info}
                      className={'border-y-tip-button'}
                      isMobileView={true}
                      activatePipMode={() => {}}
                    />
                  </div>
                ))
            : null}

          {hover || (isMobile && isMinimized) ? (
            <div className="">
              <img
                src={WhiteCloseIcon}
                alt="Logo"
                className="w-[9px] md:w-4 cursor-pointer m-[-4.5px] md:m-1 absolute top-0 left-0 lg:left-auto md:right-0"
                onClick={() => {
                  setTipBarOpen(false)
                }}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  )
}

export default TipButtonsBar
